

/**
 * Returns required field keys for a given direct sales flow page.
 *
 * - Includes all active cats for cat pages.
 * - Falls back to user fields for non-cat pages.
 */

import { FieldKey } from "../../shared/types";
import { DirectSalesFlowSlug } from "../constants";
import { useDirectSalesFlowStore } from "../hooks";
import { requiredFieldsBySlug } from "./requiredFieldsBySlug";


export const getRequiredFieldsForSlug = (slug: DirectSalesFlowSlug): FieldKey[] => {
  const { cats } = useDirectSalesFlowStore.getState();
  const getFieldsForSlug = requiredFieldsBySlug[slug];

  const requiredFields: FieldKey[] = [];

  for (const [ catId, cat ] of Object.entries(cats)) {
    if (!cat.softDelete) {
      const catFields = getFieldsForSlug({ cat, catId });
      requiredFields.push(...catFields);
    }
  }

  if (requiredFields.length === 0) {
    const userFields = getFieldsForSlug({});
    requiredFields.push(...userFields);
  }

  return requiredFields;
};
